import { Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslate } from 'react-admin';

export const BulkActionsSection = () => {

  const translate = useTranslate();

  return (
    <Grid container display="flex" flexDirection="row" justifyContent="flex-end">
      <Grid xs={3} >
        <button type="button" className="device-action-button" onClick={() => {}}>
          <DeleteIcon />
          <span>{translate('ra.action.delete')}</span>
        </button>
      </Grid>
    </Grid>
  );

};
